type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
};

export default function SectionHeading({ eyebrow, title, description, align = 'left' }: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={`mb-8 md:mb-10 ${isCenter ? 'text-center' : ''}`}>
      {eyebrow && (
        <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-label text-primary-700">
          <i className="ri-bookmark-3-line"></i>
          {eyebrow}
        </span>
      )}
      <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">{title}</h2>
      {description && (
        <p className={`mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base ${isCenter ? 'mx-auto' : ''}`}>
          {description}
        </p>
      )}
    </div>
  );
}